import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import {useSearchParams} from '@github-ui/use-navigate'
import {useQuery} from '@github-ui/react-query'
import type {ModelsSearchFiltersPayload} from '../types'

/**
 * Load the valid values for searching GitHub Models by its supported filters, such as by publisher or category.
 */
export function useModelsSearchFilters() {
  const [searchParams] = useSearchParams()
  return useQuery<ModelsSearchFiltersPayload>({
    queryKey: ['github-models', 'search-filters'],
    async queryFn() {
      const res = await verifiedFetchJSON('/models/search-filters')
      if (res.ok) return await res.json()
      return {publishers: []}
    },
    initialData: {publishers: []},
    enabled: searchParams.get('type') === 'models',
  })
}
